import { render, staticRenderFns } from "./CollegeLogo.vue?vue&type=template&id=55329bf0&"
import script from "./CollegeLogo.vue?vue&type=script&lang=ts&"
export * from "./CollegeLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports